import React from 'react';
import ErrorIcon from './errorIcon';

import './inlineError.scss';

export default ({ error = {}, text = '' }) => {
  return (
    <div className="inline-error">
      <div className="inline-error__row">
        <div className="inline-error__code">{error.code || 500}</div>
        <div className="inline-error__icon">
          <ErrorIcon backgroundColor="#49535b" foregroundColor="#ffffff" />
        </div>
      </div>
      {text && <div className="inline-error__text">{text}</div>}
    </div>
  );
};
